<template>
	<div class="registro">
		<transition name="fade">
			<div class="app-loader">
				<img src="./../../assets/cndef-loader.gif" alt="Cargando...">
			</div>
		</transition>
		<div class="registro-container">
			<div class="registro-left">
				<div class="tiras-top">
					<div class="tira-azul"></div>
					<div class="tira-roja"></div>
				</div>
				<div class="registro-form">
					<router-link :to="{ name: 'home' }" class="logo">
						<img src="../../assets/LogoNacionalTickets.svg" alt="Nacional Tickets">
						<span>Nacional<br>Tickets</span>
					</router-link>
					<h1>Registro</h1>
					<p>Completa el siguiente formulario para crear tu cuenta</p>
					<form action="" @submit.prevent="registro" novalidate="true">
						<div class="input-group">
							<label for="email" class="label-required">Correo electrónico</label>
							<input tabindex="1" type="email" name="email" id="email" class="no-icon" placeholder="prudencio@reyes.com" v-model.trim="email">
							<!-- <at-sign-icon></at-sign-icon> -->
						</div>
						<div class="input-row">
							<div class="input-group">
								<label for="password" class="label-required">Contraseña</label>
								<input tabindex="2" :type="btnPasswordType" name="password" id="password" class="no-icon" v-model.trim="password">
								<!-- <key-icon></key-icon> -->
							</div>
							<div class="input-group">
								<label for="password" class="label-required">Repetir contraseña</label>
								<div class="input-group-input">
									<input tabindex="3" :type="btnPasswordType" name="repeatPassword" id="repeatPassword" class="no-icon" v-model.trim="repeatPassword">
									<button type="button" class="togglePassword" tabindex="4" @click.prevent="togglePassword"><eye-icon class="password-show" v-if="!showPassword"></eye-icon><eye-off-icon class="password-hide" v-else></eye-off-icon></button>
									<!-- <key-icon></key-icon> -->
								</div>
							</div>
						</div>
						<div class="input-row">
							<div class="input-group">
								<label for="nombre" class="label-required">Nombres</label>
								<input type="text" id="nombre" name="nombre" class="no-icon" placeholder="Prudencio" tabindex="5" v-model="nombre">
							</div>
							<div class="input-group">
								<label for="apellido" class="label-required">Apellidos</label>
								<input type="text" id="apellido" name="apellido" class="no-icon" placeholder="Reyes" tabindex="6" v-model="apellido">
							</div>
						</div>
						<div class="input-row">
							<div class="input-group">
								<label for="documentoTipo" class="label-required">Tipo de documento</label>
								<select name="documentoTipo" id="documentoTipo" class="no-icon" tabindex="7" v-model="documentoTipo">
									<option v-for="docTipo in documentosTipoArr" :value="docTipo.DocumentoTipoId" :key="docTipo.DocumentoTipoId">{{ docTipo.DocumentoTipoNombre }}</option>
								</select>
							</div>
							<div class="input-group">
								<label for="documento" class="label-required">Documento</label>
								<div class="input-group-input">
									<input type="text" name="documento" id="documento" tabindex="8" placeholder="Ej: 12345678" v-model.trim="documento" />
									<credit-card-icon></credit-card-icon>
								</div>
							</div>
						</div>
						<div class="input-group">
							<label for="telefono" class="label-required">Celular</label>
							<div class="input-group-input">
								<input type="text" name="telefono" id="telefono" tabindex="9" v-model.trim="telefono" />
								<smartphone-icon></smartphone-icon>
							</div>
						</div>
						<div class="input-row">
							<div class="input-group input-group-33 input-socio">
								<label for="socioNro" class="label-opcional">Número de socio</label>
								<div class="input-group-input">
									<input type="text" id="socioNro" name="socioNro" tabindex="10" v-model.trim="socioNro">
									<hash-icon></hash-icon>
								</div>
							</div>
							<div class="input-group input-group-66">
								<label for="butacaNro" class="label-opcional">Código de butaca</label>
								<input type="text" id="butacaNro" name="butacaNro" class="no-icon" tabindex="11" v-model.trim="butacaNro">
							</div>
						</div>
						<div class="registro-errors" v-if="$store.state.erroresRegistro.length">
							<ul>
								<li>{{ this.$store.state.erroresRegistro[0].msg }}</li>
							</ul>
						</div>
						<div class="input-row row-terminos">
							<div class="terminos">
								<input type="checkbox" id="acepta-terminos" name="acepta-terminos" tabindex="12" v-model="aceptaTerminos">
								<label for="acepta-terminos">Acepto los&nbsp;<a @click.prevent="mostrarTerminos" tabindex="13">&nbsp;términos y condiciones</a></label>
							</div>
							<!-- <button type="submit" tabindex="14">Registrarse</button> -->
							<VueLoadingButton type="submit" aria-label="" :loading="isLoadingBoton">Registrarse</VueLoadingButton>
						</div>
						<!-- <div class="or">
							<span>o</span>
						</div>
						<div class="input-row">
							<div class="login-social login-facebook">
								<img src="../../assets/facebook.png" alt="Facebook">Continuar con Facebook
							</div>
							<div class="login-social login-google">
								<svg xmlns="http://www.w3.org/2000/svg" width="17px" height="17px" viewBox="0 0 16.677 17"><path d="M68.579,55.29l-.086-.364H60.584v3.348h4.725a4.73,4.73,0,0,1-4.627,3.556,5.533,5.533,0,0,1-3.724-1.484,5.316,5.316,0,0,1-1.586-3.752,5.483,5.483,0,0,1,1.557-3.748,5.3,5.3,0,0,1,3.7-1.447,4.825,4.825,0,0,1,3.147,1.226l2.379-2.367a8.417,8.417,0,0,0-5.6-2.158A8.391,8.391,0,0,0,52,56.6,8.541,8.541,0,0,0,54.326,62.5a8.873,8.873,0,0,0,6.4,2.6,7.891,7.891,0,0,0,5.747-2.416,8.486,8.486,0,0,0,2.207-5.878,9.788,9.788,0,0,0-.1-1.516Z" transform="translate(-52 -48.1)" fill="currentColor"></path></svg>Continuar con Google
							</div>
						</div> -->
					</form>
					<div class="iniciar-sesion">
						<span>¿Ya tienes una cuenta?</span>
						<router-link :to="{name: 'login' }" tabindex="15">Iniciar sesión</router-link>
					</div>
				</div>
				<div class="footer">
					<span>Club Nacional de Football © {{ new Date().getFullYear() }}</span>
				</div>
			</div>
			<auth-right></auth-right>
		</div>
		<modal name="terminos-modal" :scrollable="true" classes="terminos-modal" height="auto">
			<h2>Términos y condiciones</h2>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
			<h4>Título de prueba</h4>
			<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Fugit atque repellat laborum suscipit reiciendis quisquam, nobis et dolores aperiam ipsum voluptatibus rerum voluptates, alias deserunt aut voluptatum aliquid officiis ad. Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem, ab sunt perspiciatis distinctio aliquid doloremque explicabo non? Totam a voluptatibus quam voluptatem id voluptas accusantium quidem quae. Magnam, maiores aperiam. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa, velit reprehenderit ipsum facere vel nostrum ex praesentium at asperiores, minus tempore, corrupti quaerat natus maiores nisi. Debitis nemo laborum labore!</p>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import VueLoadingButton from 'vue-loading-button'
	import { EyeIcon, EyeOffIcon, CreditCardIcon, SmartphoneIcon, HashIcon } from 'vue-feather-icons'
	import AuthRight from '../../components/Shared/AuthRight.vue'

	export default {
		name: 'registro',
		data() {
			return {
				email: '',
				password: '',
				repeatPassword: '',
				nombre: '',
				apellido: '',
				documentoTipo: 1,
				documento: '',
				telefono: '',
				socioNro: '',
				butacaNro: '',
				aceptaTerminos: false,
				btnPasswordType: 'password',
				showPassword: false,
				documentosTipoArr: [],
				isLoadingBoton: false
			}
		},
		components: {
			'auth-right': AuthRight,
			EyeIcon,
			EyeOffIcon,
			CreditCardIcon,
			HashIcon,
			SmartphoneIcon,
			VueLoadingButton
		},
		beforeCreate(){
			window.location.href = process.env.VUE_APP_URL_NACIONALUY;

			// if(this.$store.getters.loggedIn === true){
			// 	this.$router.push({ name: 'home' })
			// }
		},
		methods: {
			registro() {
				this.isLoadingBoton = true;
				this.$store.commit('limpiarErroresRegistro');

				if(!this.email){
					this.$store.commit('insertarErrorRegistro', 'Ingresa un correo electrónico');
					this.isLoadingBoton = false;
					// this.errors.push({msg: 'Ingresa un correo electrónico'});
				} else {
					if(!this.validarEmail(this.email)){
						this.$store.commit('insertarErrorRegistro', 'Correo electrónico no válido');
						this.isLoadingBoton = false;
					} else {
						if(!this.password){
							this.$store.commit('insertarErrorRegistro', 'Ingresa una contraseña');
							this.isLoadingBoton = false;
						} else {
							if(this.password.length < 6){
								this.$store.commit('insertarErrorRegistro', 'Contraseña debe contener al menos 6 caracteres');
								this.isLoadingBoton = false;
							} else {
								if(!this.repeatPassword){
									this.$store.commit('insertarErrorRegistro', 'Repite la contraseña');
									this.isLoadingBoton = false;
								} else {
									if(this.repeatPassword !== this.password){
										this.$store.commit('insertarErrorRegistro', 'Contraseñas no coinciden');
										this.isLoadingBoton = false;
									} else {
										if(!this.nombre){
											this.$store.commit('insertarErrorRegistro', 'Ingresa tus nombres');
											this.isLoadingBoton = false;
										} else {
											if(!this.apellido){
												this.$store.commit('insertarErrorRegistro', 'Ingresa tus apellidos');
												this.isLoadingBoton = false;
											} else {
												if(!this.documento){
													this.$store.commit('insertarErrorRegistro', 'Ingresa un documento');
													this.isLoadingBoton = false;
												} else {
													if(!this.telefono){
														this.$store.commit('insertarErrorRegistro', 'Ingresa un telefono');
														this.isLoadingBoton = false;
													} else {
														if(this.telefono.length < 8){
															this.$store.commit('insertarErrorRegistro', 'Teléfono inválido');
															this.isLoadingBoton = false;
														} else {
															if(!this.aceptaTerminos){
																this.$store.commit('insertarErrorRegistro', 'Debes aceptar los términos y condiciones');
																this.isLoadingBoton = false;
															} else {
																// Validación Ok -> Registro usuario
																this.$store.dispatch('registrarUsuario', {
																	email: this.email,
																	password: this.password,
																	nombre: this.nombre,
																	apellido: this.apellido,
																	documentoTipo: this.documentoTipo,
																	documento: this.documento,
																	telefono: this.telefono,
																	socioNro: this.socioNro,
																	butacaNro: this.butacaNro
																})
																.then(response => {
																	this.isLoadingBoton = false;
																	this.$router.push('registro-finalizar')
																})
																.catch(error => {
																	this.isLoadingBoton = false;
																})
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			togglePassword() {
				if(this.btnPasswordType === 'password') {
					this.btnPasswordType = 'text'
					this.showPassword = true
				} else {
					this.btnPasswordType = 'password'
					this.showPassword = false
				}
			},
			mostrarTerminos(){
				this.$modal.show('terminos-modal')
			},
			validarEmail(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			}
		},
		mounted(){
			axios.post('/WSDocumentoTipo', {

			})
			.then(response => {
				var documentosTipo = response.data.SDTDocumentoTipo;
				var i = 0;
				for(i=0; i<documentosTipo.length; i++){
					this.documentosTipoArr.push(documentosTipo[i]);
				}
			})
			.catch(error => {
				reject(error)
			})
		}
	}
</script>

<style lang="scss">
	.terminos-modal{
		margin-top: 20px !important;
		margin-bottom: 20px !important;
		padding: 25px;
		height: auto !important;
		width: 90% !important;
		max-width: 700px !important;
		top: 0 !important;
		left: 0 !important;
		margin: 0 auto;

		h2{
			font-size: 18px;
			margin: 0;
			margin-bottom: 10px;
		}

		h4{
			font-size: 15px;
			margin: 0;
			margin-bottom: 5px;
		}

		p{
			font-size: 13px;
			font-weight: 400;
			line-height: 1.4em;
			text-align: justify;
			margin: 0;
		}
	}
</style>

<style scoped lang="scss">
	.registro{
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;

		.registro-container{
			width: 100%;
			height: 100vh;
			@include flex(row, space-betweeen, center);
			position: relative;
			padding: 0;

			.registro-left{
				position: relative;
				width: 800px;
				height: 100vh;
				padding: 0px 24px;
				margin: 0;
				@include flex(column, space-between, center);

				.registro-form{
					margin: 0;
					padding: 0;
					width: 100%;
					max-width: 550px;

					.logo{
						@include flex(row, flex-start, center);
						margin: 0;
						margin-bottom: 15px;
						text-decoration: none;
						color: #c61431;
						max-width: 150px;

						img{
							height: 36px;
							width: auto;
							margin-right: 15px;
						}

						span{
							// font-family: 'Bungee', sans-serif;
							font-size: 17px;
							color: #c61431;
							line-height: 1.2em;
						}

						&:hover{
							text-decoration: none;
						}
					}

					h1{
						// font-size: 30px;
						// margin: 0;
						// font-weight: 400;
						// color: #29355c;
						font-size: 28px;
						margin: 0;
						margin-top: 15px;
						font-weight: 300;
						color: #29355c;
						display: inline-block;
					}

					p{
						margin: 10px 0;
						margin-top: 0;
						color: #29355c;
						font-size: 14px;
					}

					.registro-errors{
						@include flex(row, flex-start, center);
						width: 100%;
						padding: 0;
						margin: 10px 0;

						ul{
							list-style: none;
							margin: 0;
							padding: 0;

							li{
								width: 100%;
								font-size: 13px;
								font-weight: 700;
								color: #c61431;
								line-height: 1.5em;
							}
						}
					}

					form{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.input-group{
							width: 100%;
							margin: 8px 0;
							position: relative;
							@include flex(column, flex-start, flex-start);

							.input-group-input{
								width: 100%;
								margin: 0;
								padding: 0;
								position: relative;

								svg{
									color: rgba(48, 62, 103, 0.5);
									width: 18px;
									height: 18px;
									position: absolute;
									top: 50%;
									left: 15px;
									transform: translateY(-50%);
								}
							}

							// svg{
							// 	color: rgba(48, 62, 103, 0.5);
							// 	width: 18px;
							// 	height: 18px;
							// 	position: absolute;
							// 	top: 33px;
							// 	left: 15px;
							// }

							label{
								margin-bottom: 4px;
								font-weight: 600;
								color: #29355c;
								font-size: 13px;

								&.label-required:after{
									content: '*';
									color: red;
									margin-left: 5px;
									font-weight: 300;
									font-size: 12px;
								}

								&.label-opcional:after{
									content: '(opcional)';
									color: rgba(41, 53, 92, 0.7);
									margin-left: 5px;
									font-weight: 300;
									font-size: 12px;
								}
							}

							input, select{
								width: 100%;
								outline: none;
								border: 1px solid #e6e6e6;
								border-radius: 4px;
								padding: 12px 14px 12px 42px;
								// padding: 12px 14px;
								font-size: 13px;
								background-color: #fff;
								box-shadow: none;
								transition: all .2s;
								color: #29355c;
								@include sinApariencia();

								&:focus{
									background-color: #fff;
									border: 1px solid #007bff;
								}

								&.no-icon{
									padding-left: 14px;
								}

								&#repeatPassword{
									padding: 12px 42px 12px 14px;
								}
							}

							select{
								@include isSelect();
								cursor: pointer;
							}

							.togglePassword{
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
								right: 15px;
								left: auto;
								width: 18px;
								height: 18px;
								padding: 0;
								background-color: transparent;
								background: none;
								@include flex(row, center, center);

								svg{
									color: rgba(48, 62, 103, 0.5);
									margin: 0;
									width: 18px;
									height: 18px;
									stroke-width: 2px;
									top: inherit;
									left: inherit;
								}

								&:focus{
									svg{
										color: #007bff;	
									}
								}
							}

							&.input-socio{
								position: relative;

								input{
									background-color: #fff;
									border-radius: 0;
									font-weight: 900;
									letter-spacing: 0.3px;
									color: #c61431;
									@include sinApariencia();

									&:focus{
										border-color: #f3f3f9;
									}
								}

								&:after{
									content: '';
									position: absolute;
									top: 22px;
									left: 0;
									width: 100%;
									height: 6px;
									background-color: #172e84;
									z-index: 99;
								}

								&:before{
									content: '';
									position: absolute;
									bottom: 0;
									left: 0;
									width: 100%;
									height: 6px;
									background-color: #172e84;
									z-index: 99;
								}

								svg{
									color: #c61431;
									stroke-width: 2.5px;
								}
							}
						}

						.input-row{
							margin: 8px 0;
							width: 100%;
							padding: 0;
							@include flex(row, space-between, center);

							.input-group{
								margin: 0;
								width: calc(50% - 10px);

								&.input-group-33{
									width: calc(33.33% - 10px);
								}

								&.input-group-66{
									width: calc(66.66% - 10px);
								}
							}
						}

						.login-social{
							width: 50%;
							border: 1px solid rgba(0,0,0,.1);
							padding: 0px 12px;
							border-radius: 99px;
							height: 40px;
							@include flex(row, flex-start, center);
							cursor: pointer;
							font-weight: 600;
							font-size: 14px;
							line-height: 0em;
							transition: all .2s;

							svg, img{
								width: 20px;
								height: auto;
								margin-right: 12px;
								transition: all .2s;
							}

							&.login-facebook{
								margin-right: 7px;
								color: #fff;
								border-color: #4267b2;
								background-color: #4267b2;
							}

							&.login-google{
								margin-left: 7px;
								color: #fff;
								border-color: #4285f4;
								background-color: #4285f4;
							}

							&:hover{
								opacity: 0.9;
							}
						}

						// button{
						// 	width: auto;
						// 	margin: 0;
						// 	padding: 10px 24px;
						// 	background-color: #c61431;
						// 	color: #fff;
						// 	font-weight: 600;
						// 	font-size: 14px;
						// 	outline: none;
						// 	border: none;
						// 	border-radius: 4px;
						// 	cursor: pointer;
						// 	transition: all .2s;

						// 	&:hover{
						// 		background-color: #172e84;
						// 	}

						// 	&:disabled{
						// 		color: rgba(27, 46, 75, 0.9);
						// 		background-color: #ddd;
						// 		cursor: not-allowed;
						// 	}
						// }

						button{
							width: auto;
							margin: 0;
							padding: 13px 30px;
							background-color: #11244d;
							color: #fff;
							font-weight: 400;
							font-size: 12px;
							text-transform: uppercase;
							letter-spacing: 2px;
							outline: none;
							border: none;
							border-radius: 5px;
							cursor: pointer;
							transition: all .2s;

							&:hover{
								background-color: #c61431;
							}

							&:disabled{
								color: rgba(27, 46, 75, 0.9);
								background-color: #ddd;
								cursor: not-allowed;
							}
						}

						.terminos{
							@include flex(row, flex-start, center);

							// input{
							// 	margin: 0;
							// 	width: 16px;
							// 	height: 16px;
							// 	margin-right: 6px;
							// 	margin-top: -2px;
							// 	cursor: pointer;
							// 	@include sinApariencia();
							// }

							label{
								@include flex(row, flex-start, center);
								font-size: 14px;
								line-height: 1em;

								a{
									color: #007bff;
									transition: all .2s;
									font-size: 14px;
									line-height: 1em;
									@include flex(row, center, center);
									cursor: pointer;
									margin-left: 4px;

									&:focus{
										outline: none;
										opacity: 0.9;
									}
								}

								svg{
									width: 14px;
									height: 14px;
									margin-right: 5px;
									margin-bottom: 1px;
								}
							}

							input{
								@include isCheckbox();
							}
						}

						.or{
							width: 100%;
							margin: 8px 0;
							position: relative;
							@include flex(row, center, center);

							&:after{
								content: '';
								display: block;
								position: absolute;
								top: 0;
								bottom: 0;
								height: 1px;
								background: rgba(0, 0, 0, 0.1);
								margin: auto;
								width: 100%;
							}

							span{
								padding: 10px;
								z-index: 9;
								background-color: #fff;
								line-height: 1em;
								color: rgba(0, 0, 0, 0.5);
							}
						}
					}

					.iniciar-sesion{
						width: 100%;
						@include flex(row, center, center);
						padding: 10px 0;

						span{
							font-weight: 300;
							font-size: 14px;
							margin-right: 3px;
						}

						a{
							font-weight: 500;
							font-size: 14px;
							margin-left: 3px;

							&:focus{
								outline: none;
							}
						}
					}
				}

				.tiras-top{
					height: 50px;
					width: 30px;
					background-color: #fff;
					margin-bottom: 40px;
					@include flex(row, space-between, center);

					.tira-azul{
						background-color: #172e84;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}

					.tira-roja{
						background-color: #c61431;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}
				}

				.footer{
					width: 100%;
					padding: 20px 0;
					@include flex(column, center, center);

					span{
						font-weight: 400;
						font-size: 12px;
						line-height: 1em;
					}
				}
			}
		}
	}



// @supports(-webkit-appearance: none) or (-moz-appearance: none) {
// 	input[type='checkbox']{
		
// 	}

// 	input[type='checkbox'] {
// 		&:not(.switch) {
// 			border-radius: 4px;

// 			&:after {
// 				width: 5px;
// 				height: 9px;
// 				border: 2px solid var(--active-inner);
// 				border-top: 0;
// 				border-left: 0;
// 				left: 6px;
// 				top: 3px;
// 				transform: rotate(var(--r, 20deg));
// 			}

// 			&:checked {
// 				--r: 43deg;
// 			}
// 		}
// 	}
// }

	/* Responsive */
	@media screen and (max-width: 1360px){
		.registro{
			.registro-container{
				.registro-left{
					width: 700px;
				}

				.auth-right{
					width: calc(100% - 700px);
					background-size: auto;
				}
			}
		}
	}

	@media screen and (max-width: 1260px){
		.registro{
			.registro-container{
				.registro-left{
					width: 600px;
					
					.registro-form{
						max-width: 380px;

						form{
							.input-row{
								&.row-terminos{
									@include flex(column, flex-start, flex-start);

									.terminos{
										margin-bottom: 10px;
									}

									button{
										width: 100%;
									}
								}

								.input-group{
									label{
										&.label-opcional:after{
											content: none;
										}
									}
								}
							}
						}
					}
				}

				.auth-right{
					width: calc(100% - 600px);
					background-size: auto;
				}
			}
		}
	}

	@media screen and (max-width: 960px){
		.registro{
			.registro-container{
				.registro-left{
					width: 100%;
					
					.registro-form{
						max-width: 450px;
					}
				}

				.auth-right{
					display: none;
				}
			}
		}
	}

	@media screen and (max-width: 500px){
		.registro{
			.registro-container{
				.registro-left{
					.tiras-top{
						height: 30px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 390px){
		.registro{
			.registro-container{
				.registro-left{
					width: 100%;
					
					.registro-form{
						form{
							.input-row{
								.input-group{
									width: calc(50% - 6px);
								}
							}

							.input-group{
								input, select{
									padding: 10px 10px 10px 34px;
									font-size: 12px;
								}

								.input-group-input{
									#repeatPassword{
										padding-right: 34px;
									}

									svg{
										width: 16px;
										height: 16px;
										left: 12px;
									}
								}

								&.input-socio{
									svg{
										left: 8px;
									}
								}

								.togglePassword{
									width: 16px;
									height: 16px;
									right: 12px;
									left: auto;

									svg{
										left: auto;
									}
								}
							}

							.input-row{
								.input-group{
									&.input-group-66{
										width: calc(50% - 10px);
									}

									&.input-group-33{
										width: calc(50% - 10px);
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>